import {useDispatch} from 'react-redux';

import {getLocalizationService} from '~/shared/services/localisationService';
import {setCurrentModal} from '~/shared/store/actions';
import {MoneyCard} from '~/shared/services/bffService/api/interfaces/responses';
import {cancelMoneycard} from '~/shared/services/bffService/api';
import {createLogger} from '~/shared/logging/logging';
import {replaceRoute} from '~/shared/router/router';

import cancel10bisCard from './assets/cancel10bisCard.png';
import goodByeImage from './assets/goodByeImage.svg';
import removeMoneycardErrorImage from './assets/removeMoneycardErrorImage.svg';

const logger = createLogger('useCancelMoneycard');

const useCancelMoneycard = ({currentMoneycard}: {currentMoneycard: MoneyCard | null}) => {
  const dispatch = useDispatch();
  const {t} = getLocalizationService();

  const onClick = async () => {
    if (!currentMoneycard) {
      logger.warn('No current moneycard found, cannot cancel moneycard');
      return;
    }

    dispatch(setCurrentModal('cancelMoneycard', {
      imgSrc: cancel10bisCard,
      header: `${t('cancel_10bis_card')} ${currentMoneycard.cardLastDigits}`,
      subHeader: t('cancel_card_warning'),
      primaryButton: {
        label: t('confirm_cancel_card'),
        onClick: async () => {
          try {
            await cancelMoneycard(currentMoneycard.id);
            dispatch(setCurrentModal('cancelMoneycard', {
              imgSrc: goodByeImage,
              header: t('moneycard_xxxx_cancelled_successfully', {fourDigits: currentMoneycard.cardLastDigits}),
              primaryButton: {
                label: t('close_2'),
                onClick: () => {
                  replaceRoute('/personal-area', {keepAllQueries: false});
                },
              },
            }));
          } catch (error) {
            // TODO: handle 401

            dispatch(setCurrentModal('cancelMoneycard', {
              imgSrc: removeMoneycardErrorImage,
              header: t('moneycard_cancel_failed_title'),
              subHeader: t('moneycard_cancel_error_description'),
              primaryButton: {
                label: t('close_2'),
                onClick: () => {
                  dispatch(setCurrentModal(null));
                },
              },
            }));
          }
        },
      },
      secondaryButton: {
        label: t('cancel_card_decline'),
        onClick: () => {
          dispatch(setCurrentModal(null));
        },
      },
    }));
  };

  return {onClick};
};

export default useCancelMoneycard;
